import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, applyActionCode } from 'firebase/auth';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';

const VerifyEmail = () => {
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const verifyEmail = async () => {
      const urlParams = new URLSearchParams(location.search);
      const mode = urlParams.get('mode');
      const oobCode = urlParams.get('oobCode');
      
      console.log("🔐 VerifyEmail: Processing verification", { mode, oobCode });
      
      // Обрабатываем только подтверждение email, сброс пароля обрабатывается в ResetPassword
      if (mode === 'verifyEmail' && oobCode) {
        try {
          const auth = getAuth();
          
          // 🚀 БОЕВАЯ РЕАЛИЗАЦИЯ: применяем код через Firebase
          // Firebase сам проверяет валидность и срок действия кода
          await applyActionCode(auth, oobCode);
          
          // Обновляем статус в Firestore
          const db = getFirestore();
          const userRef = doc(db, 'webUsers', auth.currentUser?.uid || '');
          await updateDoc(userRef, {
            emailVerified: true,
            verifiedAt: new Date().toISOString()
          });
          
          setStatus('success');
          setMessage('✅ Email успешно подтвержден! Теперь вы можете войти в аккаунт.');
          
          // Перенаправляем на страницу входа через 3 секунды
          setTimeout(() => {
            navigate('/');
          }, 3000);
        } catch (error) {
          console.error('❌ Verification error:', error);
          setStatus('error');
          
          if (error.code === 'auth/expired-action-code') {
            setMessage('❌ Срок действия ссылки истек. Запросите новое письмо.');
          } else if (error.code === 'auth/invalid-action-code') {
            setMessage('❌ Неверная ссылка подтверждения.');
          } else {
            setMessage('❌ Ошибка подтверждения email. Попробуйте позже.');
          }
        }
      } else if (mode === 'resetPassword') {
        // Перенаправляем на страницу сброса пароля
        navigate(`/reset-password${location.search}`);
      } else {
        setStatus('error');
        setMessage('❌ Неверная ссылка для подтверждения.');
      }
    };
    
    verifyEmail();
  }, [location, navigate]);

  if (status === 'verifying') {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#180749] to-[#2a0f6e] flex items-center justify-center p-4">
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 w-full max-w-md text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <h2 className="text-2xl font-bold text-white mb-2">Подтверждение email</h2>
          <p className="text-white/70">Пожалуйста, подождите...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#180749] to-[#2a0f6e] flex items-center justify-center p-4">
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 w-full max-w-md text-center">
        {status === 'success' ? (
          <>
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Email подтвержден!</h2>
            <p className="text-white/70 mb-4">{message}</p>
            <p className="text-white/50 text-sm">Перенаправление на страницу входа...</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Ошибка</h2>
            <p className="text-white/70 mb-4">{message}</p>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-2 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold hover:opacity-90 transition"
            >
              На главную
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;